import { TextFieldHelper } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserTextsVO } from "./common/TeaserTextsVO";
import { TeaserVO } from "./common/TeaserVO";

import MovieClip = createjs.MovieClip;

export class FeedbackBoxTeaser extends AbstractTeaser {
    private _txtTitle: TextField;
    private _btnOk: MovieClip;
    private _tf_table: TextField;
    private _tf_btnPlayLabel: TextField;
    private _tf_tournamentState: TextField;
    private _tf_freezOut: TextField;

    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super(featureId, teaserMc, teaserVO);
    }

    protected buildHook(): void {
        this._txtTitle = this._teaserMc.txt_title;

        this._btnOk = this._teaserMc.btn_ok;

        this._teaserMc.content.mouseChildren = false;
        this._tf_tournamentState = this._teaserMc.content.txt_tournamentState;
        this._tf_btnPlayLabel = this._teaserMc.content.txt_btnPlay;
    }

    public fillTexts(vo: TeaserTextsVO): void {
        super.fillTexts(vo);

        this._txtTitle.text = vo.titleStr;

        TextFieldHelper.changeTextFromatSizeByTextWidth(16, this._tf_tournamentState, Poker2Model.languageData.getTextById("menu_btn_tournierregister_title"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(15, this._tf_btnPlayLabel, Poker2Model.languageData.getTextById("generic_login_play"));
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        var textVO: TeaserTextsVO = (vo == null) ? this._teaserVO.teaserTextsVO : vo;

        this._btnOk.label = textVO.btnOkLabel;
    }
}
classImplementsInterfaces(FeedbackBoxTeaser, "Container");
